export interface CarBrandOption {
  slug: string;
  label: string;
}

/** Slugs match car-logos-dataset on jsDelivr (thumb/{slug}.png). */
const CAR_BRANDS: CarBrandOption[] = [
  { slug: "acura", label: "Acura" },
  { slug: "alfa-romeo", label: "Alfa Romeo" },
  { slug: "aston-martin", label: "Aston Martin" },
  { slug: "audi", label: "Audi" },
  { slug: "bentley", label: "Bentley" },
  { slug: "bmw", label: "BMW" },
  { slug: "bugatti", label: "Bugatti" },
  { slug: "buick", label: "Buick" },
  { slug: "byd", label: "BYD" },
  { slug: "cadillac", label: "Cadillac" },
  { slug: "chery", label: "Chery" },
  { slug: "chevrolet", label: "Chevrolet" },
  { slug: "chrysler", label: "Chrysler" },
  { slug: "citroen", label: "Citroën" },
  { slug: "cupra", label: "Cupra" },
  { slug: "dodge", label: "Dodge" },
  { slug: "ferrari", label: "Ferrari" },
  { slug: "fiat", label: "Fiat" },
  { slug: "ford", label: "Ford" },
  { slug: "genesis", label: "Genesis" },
  { slug: "gmc", label: "GMC" },
  { slug: "great-wall", label: "Great Wall" },
  { slug: "gwm", label: "GWM" },
  { slug: "haval", label: "Haval" },
  { slug: "honda", label: "Honda" },
  { slug: "hummer", label: "Hummer" },
  { slug: "hyundai", label: "Hyundai" },
  { slug: "infiniti", label: "Infiniti" },
  { slug: "jac", label: "JAC" },
  { slug: "jaguar", label: "Jaguar" },
  { slug: "jeep", label: "Jeep" },
  { slug: "kia", label: "Kia" },
  { slug: "koenigsegg", label: "Koenigsegg" },
  { slug: "lamborghini", label: "Lamborghini" },
  { slug: "land-rover", label: "Land Rover" },
  { slug: "lexus", label: "Lexus" },
  { slug: "lifan", label: "Lifan" },
  { slug: "lincoln", label: "Lincoln" },
  { slug: "lotus", label: "Lotus" },
  { slug: "lucid", label: "Lucid" },
  { slug: "maserati", label: "Maserati" },
  { slug: "mazda", label: "Mazda" },
  { slug: "mclaren", label: "McLaren" },
  { slug: "mercedes-benz", label: "Mercedes-Benz" },
  { slug: "mini", label: "Mini" },
  { slug: "mitsubishi", label: "Mitsubishi" },
  { slug: "nissan", label: "Nissan" },
  { slug: "omoda", label: "Omoda" },
  { slug: "opel", label: "Opel" },
  { slug: "peugeot", label: "Peugeot" },
  { slug: "polestar", label: "Polestar" },
  { slug: "porsche", label: "Porsche" },
  { slug: "ram", label: "RAM" },
  { slug: "renault", label: "Renault" },
  { slug: "rivian", label: "Rivian" },
  { slug: "rolls-royce", label: "Rolls-Royce" },
  { slug: "saab", label: "Saab" },
  { slug: "seat", label: "Seat" },
  { slug: "skoda", label: "Škoda" },
  { slug: "smart", label: "Smart" },
  { slug: "ssangyong", label: "SsangYong" },
  { slug: "subaru", label: "Subaru" },
  { slug: "suzuki", label: "Suzuki" },
  { slug: "tesla", label: "Tesla" },
  { slug: "toyota", label: "Toyota" },
  { slug: "volkswagen", label: "Volkswagen" },
  { slug: "volvo", label: "Volvo" },
];

/** Motorcycle brands; logos from javimogan/vehicle-logos-dataset (rounds/{slug}.png). */
const MOTO_BRANDS: CarBrandOption[] = [
  { slug: "aprilia", label: "Aprilia" },
  { slug: "ducati", label: "Ducati" },
  { slug: "harley-davidson", label: "Harley-Davidson" },
  { slug: "honda-moto", label: "Honda Moto" },
  { slug: "kawasaki", label: "Kawasaki" },
  { slug: "ktm", label: "KTM" },
  { slug: "triumph", label: "Triumph" },
  { slug: "vespa", label: "Vespa" },
  { slug: "yamaha", label: "Yamaha" },
];

export const CAR_BRAND_OPTIONS: CarBrandOption[] = [...CAR_BRANDS, ...MOTO_BRANDS].sort(
  (a, b) => a.label.localeCompare(b.label, "pt-BR")
);

const BRAND_BY_SLUG = new Map(
  CAR_BRAND_OPTIONS.map((brand) => [brand.slug, brand])
);

export const CAR_BRAND_SLUGS = new Set(CAR_BRAND_OPTIONS.map((brand) => brand.slug));

export function isValidCarBrandSlug(slug: string): boolean {
  return CAR_BRAND_SLUGS.has(slug);
}

export function getCarBrandLabel(slug?: string | null): string | null {
  if (!slug?.trim()) {
    return null;
  }
  return BRAND_BY_SLUG.get(slug.trim())?.label ?? null;
}

export function getCarBrandSelectOptions(): { value: string; label: string }[] {
  return CAR_BRAND_OPTIONS.map((brand) => ({
    value: brand.slug,
    label: brand.label,
  }));
}
